import { IonFooter } from "@ionic/react";
import { useTheme } from "react-jss";
import { FooterStyle } from "./footerStyle.jss";

interface IFooterProps {
    element: JSX.Element;
    hideBorder?: boolean;
}

export const Footer: React.FC<IFooterProps> = ({ element, hideBorder }) => {
    const theme = useTheme();
    const style = FooterStyle({ theme });

    return <IonFooter className={`${style.footer} ${!hideBorder ? "" : "ion-no-border"}`}>{element}</IonFooter>;
};
